module.exports = "/assets/landing-korw/mission/photo.jpg?MVOsOgt";